import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20cozy%20library%20interior%20with%20bookshelves%20filled%20with%20colorful%20manga%20comics%2C%20soft%20warm%20lighting%20from%20vintage%20lamps%2C%20reading%20nook%20with%20comfortable%20chairs%2C%20artistic%20illustration%20style%2C%20Korean%20webtoon%20aesthetic%2C%20warm%20cream%20and%20amber%20tones%2C%20cozy%20atmosphere%2C%20no%20text&width=1920&height=1080&seq=hero-bg-manga-01&orientation=landscape"
          alt="韩漫之家 - 漫画图书馆"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/25"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          韩漫免费漫画在线
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          精选好看的韩国漫画，支持下拉式阅读模式。来到韩漫之家，
          体验流畅沉浸的漫画阅读之旅，仿佛置身专属漫画图书馆中。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer no-underline text-sm shadow-lg shadow-primary-500/25"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-book-read-line"></i>
            </span>
            立即阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer no-underline text-sm border border-white/20"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-information-line"></i>
            </span>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">1000+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">漫画作品</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">50万+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">忠实读者</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">99.8%</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">好评率</div>
          </div>
        </div>
      </div>
    </section>
  );
}